import { render, staticRenderFns } from "./HeaderElement.vue?vue&type=template&id=16c6c2c8&"
import script from "./HeaderElement.vue?vue&type=script&lang=js&"
export * from "./HeaderElement.vue?vue&type=script&lang=js&"
import style0 from "./HeaderElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports